import { useRef, useEffect, useState } from 'react'
import {
  Chart, BarElement, LineElement, PointElement,
  LinearScale, CategoryScale, Filler, Tooltip,
  BarController, LineController,
} from 'chart.js'
import { revenueChartData, userChartData } from '../Models/dashboardData'

Chart.register(BarElement, LineElement, PointElement, LinearScale, CategoryScale, Filler, Tooltip, BarController, LineController)

const TOOLTIP = {
  backgroundColor: 'rgba(8,11,20,.95)', titleColor: '#EFF2FB',
  bodyColor: '#8B96B3', borderColor: 'rgba(99,102,241,.4)',
  borderWidth: 1, padding: 10, cornerRadius: 8,
}

export function useDashboard() {
  const revenueRef   = useRef(null)
  const userRef      = useRef(null)
  const revInst      = useRef(null)
  const usrInst      = useRef(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 500)
    return () => clearTimeout(t)
  }, [])

  useEffect(() => {
    if (loading) return

    if (revenueRef.current) {
      revInst.current?.destroy()
      revInst.current = new Chart(revenueRef.current, {
        type: 'line',
        data: {
          labels: revenueChartData.labels,
          datasets: [
            { label:'Revenue ($K)', data:revenueChartData.revenue, borderColor:'#4F46E5', backgroundColor:'rgba(79,70,229,.12)', borderWidth:2.5, fill:true, pointBackgroundColor:'#4F46E5', pointRadius:3, pointHoverRadius:5, tension:0.4 },
            { label:'Target ($K)',  data:revenueChartData.target,  borderColor:'rgba(99,102,241,.35)', borderDash:[6,4], borderWidth:1.5, pointRadius:0, fill:false, tension:0.4 },
          ],
        },
        options: {
          responsive:true, maintainAspectRatio:false,
          plugins:{ legend:{ display:false }, tooltip:TOOLTIP },
          scales:{
            x:{ ticks:{ color:'#4A5578', font:{ size:11, family:'Inter' }}, grid:{ display:false }},
            y:{ ticks:{ color:'#4A5578', font:{ size:11, family:'Inter' }}, grid:{ color:'rgba(255,255,255,.03)' }},
          },
        },
      })
    }

    if (userRef.current) {
      usrInst.current?.destroy()
      usrInst.current = new Chart(userRef.current, {
        type: 'bar',
        data: {
          labels: userChartData.labels,
          datasets: [
            { label:'New Users',    data:userChartData.newUsers,    backgroundColor:'rgba(79,70,229,.8)',  borderRadius:4, borderSkipped:false },
            { label:'Active Users', data:userChartData.activeUsers, backgroundColor:'rgba(6,182,212,.45)', borderRadius:4, borderSkipped:false },
          ],
        },
        options: {
          responsive:true, maintainAspectRatio:false,
          plugins:{ legend:{ display:false }, tooltip:TOOLTIP },
          scales:{
            x:{ ticks:{ color:'#4A5578', font:{ size:11 }}, grid:{ display:false }},
            y:{ ticks:{ color:'#4A5578', font:{ size:11 }}, grid:{ color:'rgba(255,255,255,.03)' }},
          },
        },
      })
    }

    return () => { revInst.current?.destroy(); usrInst.current?.destroy() }
  }, [loading])

  return { revenueRef, userRef, loading }
}
